import { render, staticRenderFns } from "./BoxLink.vue?vue&type=template&id=971fa004&scoped=true&"
import script from "./BoxLink.vue?vue&type=script&lang=js&"
export * from "./BoxLink.vue?vue&type=script&lang=js&"
import style0 from "./BoxLink.vue?vue&type=style&index=0&id=971fa004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "971fa004",
  null
  
)

export default component.exports